import { hasWindow } from "@utils/general";

if (typeof window !== "undefined") window.hubo = window.hubo || {};

enum WindowKeys {
    FEATURE_TOGGLES = "featureToggles",
    TRACKER = "tracker",
    VERSION = "version",
    SEARCH = "search",
    HOOKS = "hooks",
}

class WindowManagement {
    static saveObject(key: string, value: any) {
        hasWindow() && (window.hubo[key] = value);
    }

    static getObject(key: string) {
        return hasWindow() ? window.hubo[key] : undefined;
    }
}

export { WindowKeys, WindowManagement };
